import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const SuggestedReadingWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  row-gap: 20px;
`;

export const ArticlesTitle = styled.h3`
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleSubheading
      : textStyleCss(theme.atlas.typography.semantic.caption)};
  margin: 0;
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
`;

export const ArticlesList = styled.ul`
  margin: 0;
  list-style-type: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
`;

export const Article = styled.li`
  margin: 0;
  display: flex;
  column-gap: 10px;
  align-items: center;
`;

export const ArticleHelpText = styled.p`
  margin: 0;
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleBody
      : textStyleCss(theme.atlas.typography.semantic.body)};
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
`;
